import React, { Component, PropTypes } from 'react';
import { ControlledRadioButton as SparkRadioButton } from '../../../ui/sabre-spark-react-ex';
import ReactSparkTextInput from '../../../widgets/ReactSparkTextInput';
import {
    IN_CONTEXT_RESUME_BOOKING_MESSAGE,
    RESUME_BOOKING_BOTTOM_DISTANCE
} from '../../../../constants/RoomsConfiguration';

class InContextPositionDistanceControl extends Component {
    clampBottomDistance(value) {
        const parsed = Number.parseFloat(value);
        if (Number.isNaN(parsed)) {
            return RESUME_BOOKING_BOTTOM_DISTANCE.DEFAULT;
        }

        return Math.max(RESUME_BOOKING_BOTTOM_DISTANCE.MIN, Math.min(parsed, RESUME_BOOKING_BOTTOM_DISTANCE.MAX));
    }

    handleDesktopAlignmentChange = event => {
        const { value } = event.target;
        this.props.setConfigText('resumeBookingDisplayType', value);
    };

    handleMobileAlignmentChange = event => {
        const { value } = event.target;
        this.props.setConfigText('resumeBookingMobileDisplayType', value);
    };

    renderBottomDistanceInput(distanceValue, distanceConfigKey) {
        return (
            <ReactSparkTextInput
                className="indent-left bottom-margin"
                label="Distance from screen bottom (rem)"
                isDisabled={this.props.isDisabled}
                value={distanceValue !== undefined ? distanceValue : RESUME_BOOKING_BOTTOM_DISTANCE.DEFAULT}
                type="number"
                onChange={event => {
                    this.props.setConfigText(distanceConfigKey, event.target.value);
                }}
                onBlur={event => {
                    const clamped = this.clampBottomDistance(
                        event.target.value !== '' ? event.target.value : RESUME_BOOKING_BOTTOM_DISTANCE.DEFAULT
                    );
                    this.props.setConfigNumber(distanceConfigKey, clamped, true);
                }}
            />
        );
    }

    renderAlignmentGroup(options) {
        const { groupName, selectedAlignment, onAlignmentChange, distanceValue, distanceConfigKey } = options;

        return (
            <div className={options.className}>
                <div>
                    <SparkRadioButton
                        name={groupName}
                        value="bottomRight"
                        checked={selectedAlignment === 'bottomRight'}
                        onClick={onAlignmentChange}
                        disabled={this.props.isDisabled}
                    >
                        {IN_CONTEXT_RESUME_BOOKING_MESSAGE.BOTTOM_RIGHT}
                    </SparkRadioButton>
                    {selectedAlignment === 'bottomRight' &&
                        this.renderBottomDistanceInput(distanceValue, distanceConfigKey)}
                </div>
                <div>
                    <SparkRadioButton
                        name={groupName}
                        value="bottomLeft"
                        checked={selectedAlignment === 'bottomLeft'}
                        onClick={onAlignmentChange}
                        disabled={this.props.isDisabled}
                    >
                        {IN_CONTEXT_RESUME_BOOKING_MESSAGE.BOTTOM_LEFT}
                    </SparkRadioButton>
                    {selectedAlignment === 'bottomLeft' &&
                        this.renderBottomDistanceInput(distanceValue, distanceConfigKey)}
                </div>
                <div>
                    <SparkRadioButton
                        name={groupName}
                        value="bottomCenter"
                        checked={selectedAlignment === 'bottomCenter'}
                        onClick={onAlignmentChange}
                        disabled={this.props.isDisabled}
                    >
                        {IN_CONTEXT_RESUME_BOOKING_MESSAGE.BOTTOM_CENTER}
                    </SparkRadioButton>
                    {selectedAlignment === 'bottomCenter' &&
                        this.renderBottomDistanceInput(distanceValue, distanceConfigKey)}
                </div>
            </div>
        );
    }

    render() {
        const { currentConfigCopy } = this.props;

        return (
            <div>
                <h6 className="spark-mar-b-0">Location on mobile and tablet screens</h6>
                {this.renderAlignmentGroup({
                    groupName: 'in-context-resume-booking-mobile',
                    selectedAlignment: currentConfigCopy.resumeBookingMobileDisplayType || 'bottomRight',
                    onAlignmentChange: this.handleMobileAlignmentChange,
                    distanceValue: currentConfigCopy.resumeBookingMobileBottomDistance,
                    distanceConfigKey: 'resumeBookingMobileBottomDistance',
                    className: 'defaultProductViewRadioButtonGroup'
                })}
                <h6>Location on desktop screens</h6>
                {this.renderAlignmentGroup({
                    groupName: 'in-context-resume-booking',
                    selectedAlignment: currentConfigCopy.resumeBookingDisplayType || 'bottomRight',
                    onAlignmentChange: this.handleDesktopAlignmentChange,
                    distanceValue: currentConfigCopy.resumeBookingBottomDistance,
                    distanceConfigKey: 'resumeBookingBottomDistance'
                })}
            </div>
        );
    }
}

InContextPositionDistanceControl.propTypes = {
    currentConfigCopy: PropTypes.object.isRequired,
    setConfigText: PropTypes.func.isRequired,
    setConfigNumber: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
};

InContextPositionDistanceControl.defaultProps = {
    isDisabled: false
};

export default InContextPositionDistanceControl;



// WEBPACK FOOTER //
// ./src/components/pages/pages/product/InContextPositionDistanceControl.js